<template>
  <div>
    <div
      class="bg-surface-grey-light items-center flex text-sm rounded-sm p-4 text-text"
    >
      <TicketIcon class="shrink-0 w-6 h-6 fill-primary mr-2" />
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import TicketIcon from '@/components/icons/TicketIcon.vue';
</script>
